import { EligibilityCriteria } from '@frontend/user-preferences';

type ViewCountCriteria = Extract<EligibilityCriteria, { type: 'view-count' }>;

function isViewCountCriteria(criteria: EligibilityCriteria): criteria is ViewCountCriteria {
  return 'type' in criteria && criteria.type === 'view-count';
}

export function hasReachedViewLimit(criteria?: EligibilityCriteria): boolean {
  if (!criteria) return false;

  const viewCondition = isViewCountCriteria(criteria)
    ? criteria
    : 'conditions' in criteria
    ? criteria.conditions.find(isViewCountCriteria)
    : undefined;

  if (!viewCondition) return false;

  return (viewCondition.viewCount ?? 0) >= viewCondition.maxViews;
}
